import { render, staticRenderFns } from "./PageInvoiceForm.vue?vue&type=template&id=4ad62047&scoped=true"
import script from "./PageInvoiceForm.vue?vue&type=script&lang=js"
export * from "./PageInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad62047",
  null
  
)

export default component.exports